import { OPEN_MODAL, CLOSE_MODAL, UPDATE_MODAL } from './modal-actions';
import css from './modal-container.scss';

const defaultState = [];

/**
 * Modal Reducer
 *
 * Consumes OPEN_MODAL action
 * Consumes CLOSE_MODAL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of modals to display
 */
export default function(state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
        case OPEN_MODAL:
            return [
                ...state,
                {
                    id: state.length,
                    title: action.payload.title,
                    content: action.payload.content,
                    buttons: action.payload.buttons,
                    className: css.modal
                }
            ];

        case CLOSE_MODAL:
            return state.slice(0, state.length - 1);

        case UPDATE_MODAL: {
            if (!state.length) return state;
            const newState = [...state];
            newState[newState.length - 1].buttons = action.payload.buttons;
            return newState;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/modal-container/modal-reducer.js